module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/venue/venue-layouts/venue-layouts.component.scss
// module id = ./src/app/routes/venue/venue-layouts/venue-layouts.component.scss
// module chunks = 9